const data = [
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/t7vauxfrjlg2-UZ/image;s=644x461",
        title: "НАНО КИНЕТИЧЕСКИЙ ПЕСОК 5 кг + бассейн и формочки MAD MATTR",
        price: "299 900 сум",
        location: "Ташкент, Мирабадский район"
    },
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/p4tjoe7fl4wr-UZ/image;s=644x461",
        title: "Оригинальный кубик Рубика Скваер MoFangGe X-Man Volt Square-1 V2 M",
        price: "24.99 у.е.",
        location: "Ташкент, Чиланзарский район",
    }, {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/y25us078y89n1-UZ/image;s=644x461",
        title: "Игрушка горка Hello kitty",
        price: "150 000 сум",
        location: "Ташкент, Яккасарайский район",
    },
]

export default data;